// src/firebase.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  RecaptchaVerifier,
  linkWithPhoneNumber,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

/**
 * IMPORTANT: storageBucket must be the appspot.com bucket,
 * not firebasestorage.app. Otherwise uploads won’t work.
 */

const firebaseConfig = {
  apiKey: "AIzaSyCQeHRdUQUKuCoJJs3XN5zfvI6XiOO6xJc",
  authDomain: "travxplo-86c4e.firebaseapp.com",
  projectId: "travxplo-86c4e",
  storageBucket: "travxplo-86c4e.appspot.com", // ✅ corrected
  messagingSenderId: "576291431231",
  appId: "1:576291431231:web:e124ed9d00c0b480f6e98a",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);

// Helpers for Phone OTP (kept here so they’re importable)
export { RecaptchaVerifier, linkWithPhoneNumber };
